import { getNodeDeserializer } from './getNodeDeserializer.mjs';

/**
 * See {@link getNodeDeserializer}.
 */
function getElementDeserializer(options) {
  return getNodeDeserializer({
    node: () => ({
      type: options.type
    }),
    ...options
  });
}

export { getElementDeserializer };
